"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetLeakDetectionData = void 0;
const react_1 = require("react");
const LeakDetection_1 = require("../types/water/LeakDetection");
const useGetLeakDetectionData = ({ humidity, leakDetected, timestamp, }) => {
    const status = (0, react_1.useMemo)(() => {
        if (leakDetected)
            return LeakDetection_1.LeakThreshold.LeakDetected;
        if (humidity === null)
            return LeakDetection_1.LeakThreshold.InvalidData;
        if (humidity >= 71)
            return LeakDetection_1.LeakThreshold.ExtremelyHumid;
        if (humidity >= 61)
            return LeakDetection_1.LeakThreshold.HighHumidity;
        if (humidity >= 51)
            return LeakDetection_1.LeakThreshold.SlightlyHumid;
        return LeakDetection_1.LeakThreshold.NoLeak;
    }, [humidity, leakDetected]);
    const gradientColors = (0, react_1.useMemo)(() => {
        switch (status) {
            case LeakDetection_1.LeakThreshold.LeakDetected:
                return [LeakDetection_1.LeakColor.Red, LeakDetection_1.LeakColor.Red, LeakDetection_1.LeakColor.Red];
            case LeakDetection_1.LeakThreshold.ExtremelyHumid:
            case LeakDetection_1.LeakThreshold.HighHumidity:
                return [LeakDetection_1.LeakColor.Red, LeakDetection_1.LeakColor.Red, LeakDetection_1.LeakColor.Red];
            case LeakDetection_1.LeakThreshold.SlightlyHumid:
                return [LeakDetection_1.LeakColor.Yellow, LeakDetection_1.LeakColor.Yellow, LeakDetection_1.LeakColor.Yellow];
            case LeakDetection_1.LeakThreshold.NoLeak:
                return [LeakDetection_1.LeakColor.Green, LeakDetection_1.LeakColor.Green, LeakDetection_1.LeakColor.Green];
            default:
                return [LeakDetection_1.LeakColor.Green, LeakDetection_1.LeakColor.Green, LeakDetection_1.LeakColor.Green];
        }
    }, [status]);
    return {
        status,
        leakDetected: status === LeakDetection_1.LeakThreshold.LeakDetected,
        gradientColors,
        timestamp,
        humidity,
    };
};
exports.useGetLeakDetectionData = useGetLeakDetectionData;
